import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="策點文化"
        brandName="策點文化"
        englishName="STRATDOT"
        tagline="跨領域選書，建立多元閱讀視角"
      />
      <Footer />
    </>
  );
}

